import React from 'react';

const VerifiedIcon = ({ gray, className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.50906 1.93955C9.05531 1.47246 9.9499 1.47246 10.5041 1.93955L11.7549 3.01621C11.9924 3.22205 12.4357 3.3883 12.7524 3.3883H14.0982C14.9374 3.3883 15.6261 4.07705 15.6261 4.91621V6.26205C15.6261 6.5708 15.7924 7.02205 15.9982 7.25955L17.0749 8.51038C17.542 9.05663 17.542 9.95121 17.0749 10.5054L15.9982 11.7562C15.7924 11.9937 15.6261 12.437 15.6261 12.7537V14.0995C15.6261 14.9387 14.9374 15.6275 14.0982 15.6275H12.7524C12.4436 15.6275 11.9924 15.7937 11.7549 15.9995L10.5041 17.0762C9.95781 17.5433 9.06323 17.5433 8.50906 17.0762L7.25823 15.9995C7.02073 15.7937 6.5774 15.6275 6.26073 15.6275H4.89115C4.05198 15.6275 3.36323 14.9387 3.36323 14.0995V12.7458C3.36323 12.437 3.19698 11.9937 2.99906 11.7562L1.93031 10.4975C1.47115 9.95121 1.47115 9.06455 1.93031 8.5183L2.99906 7.25955C3.19698 7.02205 3.36323 6.57871 3.36323 6.26996V4.9083C3.36323 4.06913 4.05198 3.38038 4.89115 3.38038H6.26073C6.56948 3.38038 7.02073 3.21413 7.25823 3.0083L8.50906 1.93955Z",
      fill: gray ? "#FFFFFF99" : "#26BA50"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.54276 12.0096C8.38443 12.0096 8.23401 11.9463 8.12318 11.8355L6.20734 9.91964C5.97776 9.69005 5.97776 9.31005 6.20734 9.08047C6.43693 8.85089 6.81693 8.85089 7.04651 9.08047L8.54276 10.5767L11.9469 7.17255C12.1765 6.94297 12.5565 6.94297 12.7861 7.17255C13.0157 7.40214 13.0157 7.78214 12.7861 8.01172L8.96234 11.8355C8.85151 11.9463 8.70109 12.0096 8.54276 12.0096Z",
      fill: "white"
    }
  )
);
VerifiedIcon.displayName = "Icons.VerifiedIcon";

export { VerifiedIcon };
//# sourceMappingURL=VerifiedIcon.js.map
